import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { psiTokens } from '../theme/psiTheme';
import { useLanguage } from '../contexts/LanguageContext';

export default function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useLanguage();

  return (
    <Box
      sx={{
        background: `linear-gradient(90deg, #f6f0fa 0%, #f1e7f6 100%)`,
        py: 4,
        borderTop: `2px solid`,
        borderImage: `linear-gradient(90deg, ${psiTokens.primary.dark}, ${psiTokens.primary.light}) 1`,
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr auto 1fr',
            alignItems: 'center',
            gap: isMobile ? 1.5 : 0,
            textAlign: isMobile ? 'center' : 'left',
          }}
        >
          {/* Logo — pinned to the far left */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: isMobile ? 'center' : 'flex-start',
              gap: 0.5,
              justifySelf: isMobile ? 'center' : 'start',
            }}
          >
            <Box
              component="img"
              src="/PSI - Editado.png"
              alt="PSI Logo"
              sx={{
                height: '64px',
                width: 'auto',
              }}
            />
            <Typography
              component="a"
              href="https://guzalarrondo.com/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontSize: '11px',
                fontWeight: 400,
                color: '#8a7d99',
                textDecoration: 'none',
                '&:hover': { color: psiTokens.primary.light },
              }}
            >
              Developed by Guza & Larrondo Solutions
            </Typography>
          </Box>

          {/* Copyright — centered in the middle of the page */}
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              color: '#705780',
              justifySelf: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            {t('footer.copyright')}
          </Typography>

          {/* Tagline — mirrored on the far right */}
          <Typography
            sx={{
              fontSize: '15px',
              fontWeight: 400,
              fontStyle: 'italic',
              color: psiTokens.primary.light,
              letterSpacing: '0.06em',
              justifySelf: isMobile ? 'center' : 'end',
            }}
          >
            {t('footer.tagline')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
